const ExportUtil          = require("./ExportUtil.js");
const ImportUtil       = require("./ImportUtil.js");
const Utilities           = require("./Utilities.js");
const CircuitsUtil        = require("./CircuitsUtil.js");
const ObservableUtil      = require("./ObservableUtil.js");
const ContentServerClient = require("./../ContentServerClient.js");
const ApplicationContext  = require("../config/ApplicationContext.js");

class DataActionUtil{

	constructor(){
        this.editAsset = this.editAsset.bind(this);
        this.exportOBJ = this.exportOBJ.bind(this);
        this.exportSTEP = this.exportSTEP.bind(this);
        this.exportAsset = this.exportAsset.bind(this);
        this.deleteAsset = this.deleteAsset.bind(this);
        this.restoreAsset = this.restoreAsset.bind(this);
        this.publishAsset = this.publishAsset.bind(this);
        this.unpublishAsset = this.unpublishAsset.bind(this);

        this.addMember = this.addMember.bind(this);
        this.cancelInvitationMember = this.cancelInvitationMember.bind(this);
        this.deleteMember = this.deleteMember.bind(this);

        this._doActionRecursive = this._doActionRecursive.bind(this);
        this._checkHasRecursiveChildren = this._checkHasRecursiveChildren.bind(this);
        this._getRecursiveMessage = this._getRecursiveMessage.bind(this);
    }

    // preform actions on circtuis data ////////////////
    ////////////////////////////////////
    // all of these functions should take in a list of resource objects to preform their operation on,
    // and the functions setConfirmation, setLoading, and setError. (some may need other parameters, like exportType)
    // each action will use these hooks to manipulate the view.  This logic should be consilidated
    // because each action will have the same confirmation/loading/error logic,
    // even when there might be several buttons tied to the same action.
    // -- coming soon, group operations.

    editAsset(handleError, resource, setConfirmation, setLoading, setError){
        googleGA("send", "event", resource.type, "edit");
        let base = resource.type === "library" ? ApplicationContext.getPackageLibrary() : ApplicationContext.getPackageEditor();
        let win = window.open(`${base}?assetid=${resource.id}`, '_blank');
        if (win) { win.focus() }
    }

    // no outputType will result in give LBR.  outputTypes should only be for
    exportAsset(handleError, resource, setConfirmation, setLoading, setError, outputType){
        let type = outputType || resource.type;
        googleGA("send", "event", Utilities.getPath(), `export${type}`);
        setLoading(true, `Exporting ${resource.name}`);
        ExportUtil.getModel(handleError, resource.id, resource.name, type, CircuitsUtil.getMostRecentVersion(resource))
            .then(() => setLoading(false))
            .catch(() => setLoading(false))
    }

    exportSTEP(handleError, resource, setConfirmation, setLoading, setError){
        googleGA("send", "event", Utilities.getPath(), `export STEP`);

        setLoading(true, `Exporting ${resource.name}`);
        ExportUtil.getModel(handleError, resource.id, resource.name, 'STEP', CircuitsUtil.getMostRecentVersion(resource))
            .then(() => setLoading(false))
            .catch(err => setLoading(false))
    }
		
		exportF3D(handleError, resource, setConfirmation, setLoading, setError){
				googleGA("send", "event", Utilities.getPath(), `export F3D`);

				setLoading(true, `Exporting ${resource.name}`);
				ExportUtil.getModel(handleError, resource.id, resource.name, 'F3D', CircuitsUtil.getMostRecentVersion(resource))
						.then(() => setLoading(false))
						.catch(err => setLoading(false))
		}

    exportOBJ(handleError, resource, setConfirmation, setLoading, setError){
        googleGA("send", "event", Utilities.getPath(), `export STEP`);

        setLoading(true, `Exporting ${resource.name}`);
        ExportUtil.getModel(handleError, resource.id, resource.name, 'OBJ', CircuitsUtil.getMostRecentVersion(resource))
        .then(()=>{
            setLoading(false);
        })
        .catch(err => setLoading(false))
    }

    async exportLibraryAfterImport(handleError, library) {
      try {
          const status = await ImportUtil.getStatus(handleError, library.resource.id);
          if (status.type === "done") {
              await ExportUtil.exportLibrary(handleError, library)
          }
      } catch (error) {
          console.error('Error DataActionUtil exportLibraryAfterImport', error);
      }
    }

    // delete will have popups to check if delete should be done recursivly or not (based on asset types)
    deleteAsset(handleError, resource, setConfirmation, setLoading, setError){
        this._doActionRecursive(handleError, resource, "delete", "delete",
        (id, type, recursive) =>{
            return ContentServerClient.deleteAsset(handleError, id, type, recursive, true);
        },
        setConfirmation, setLoading, setError)
    }

    restoreAsset(handleError, resource, setConfirmation, setLoading, setError){
        this._doActionRecursive(handleError, resource, "restore", "delete",
        (id, type, recursive) =>{
            return ContentServerClient.deleteAsset(handleError, id, type, recursive, false);
        },
        setConfirmation, setLoading, setError)
    }
		

    publishAsset(handleError, resource, setConfirmation, setLoading, setError){
        ObservableUtil.callActionSubscribers("publish", resource.id);
        setLoading(true, `Publishing ${resource.name}`);
        let type = CircuitsUtil.getPluralFromResourceType(resource.type);
        ContentServerClient.publishAsset(handleError, resource.id, type, true, true)
        .then(res=>{
            setLoading(false);
            ObservableUtil.callChangeSubscribers("publish", resource.id, res);
        })
        .catch((err)=>{
            setLoading(false);
            ObservableUtil.callChangeSubscribers("publish", resource.id, err, true);
        })
    }

    unpublishAsset(handleError, resource, setConfirmation, setLoading, setError){
        ObservableUtil.callActionSubscribers("publish", resource.id);
        setLoading(true, `Publishing ${resource.name}`);
        let type = CircuitsUtil.getPluralFromResourceType(resource.type);
        ContentServerClient.publishAsset(handleError, resource.id, type, true, false)
        .then(res=>{
            setLoading(false);
            ObservableUtil.callChangeSubscribers("publish", resource.id, res);
        })
        .catch((err)=>{
            setLoading(false);
            ObservableUtil.callChangeSubscribers("publish", resource.id, err, true);
        })
    }

    async bulkUpload3dModels(handleError, files, packageNames, hubId, isPrivate, setLoading) {
      try {
        const validFiles = Array.from(files).filter(file => ImportUtil.validateFile(file, `^(${packageNames.join("|")})\.(step|stp|f3d)$`));
        if (validFiles.length === 0) throw new Error("No valid files selected. Please ensure that file names match package names and have STEP, STP, or F3D extensions.");

        setLoading(true, `Uploading ${validFiles.length} file${(validFiles.length > 1) ? 's' : ''}`);

        const models3d = [];
        for (let i = 0; i < validFiles.length; i++) {
          const onProgress = (text) => {
            setLoading(true, `${text}${validFiles.length > 1 ? `\n(file ${i + 1} of ${validFiles.length})` : ''}\nPlease wait until the process is done`);
          }

          const model3d = await ImportUtil.createResource3D(handleError, validFiles[i], onProgress, { hub: hubId, private: isPrivate });
          models3d.push(model3d);
          // delay to not hit requests too hard
          await Utilities.delay(500);
        }

        return models3d
      } catch (err) {
        throw err
      } finally {
        setLoading(false)
      }
    }

    async attach3dModelToPackagesInLibrary(handleError, library, models3d, setLoading) {
      try {
        if (models3d.length === 0) throw new Error("Missing 3D Models");

        const { name: libraryName, id: libraryId } = library;
        setLoading(true, `Attaching 3D Models to Packages in ${libraryName} library.\nPlease wait until the process is done`);

        const model3dMapping = models3d.map(model3d => { return { model3dId: model3d.id }});
        await ContentServerClient.attach3dModelsToPackagesInLibrary(handleError, libraryId, model3dMapping);

        const onProgress = ({ percent }) => {
          setLoading(true, `Waiting for library import to finish`, undefined, percent);
        }
        await ImportUtil.getStatus(handleError, libraryId, onProgress);
        onProgress({ percent: 100 });
        await Utilities.delay(1000); //delay to make 100% progress visible
      } catch (err) {
        throw err
      } finally {
        setLoading(false)
      }
    }

    // Use this function to share code for an action that may be preformed recursively
    // (The behavior for many of these actions is the same, confirm the action, provide a checkbox for
    //  whether or not to do it recrsivly, preform the action, then notify the listeners)
    _doActionRecursive(handleError, resource, actionName, actionId, actionFunction, setConfirmation, setLoading, setError){
        this._checkHasRecursiveChildren(handleError, resource, setLoading)
        .then( canRecurs => {

            let checkboxes = [];
            if(canRecurs){
                let message = this._getRecursiveMessage(actionName, resource.type);
                if(message){
                    let checkbox = {
                        message: message,
                        default: true
                    }
                    checkboxes = [checkbox];
                }
            }

            var capitolActionName = actionName.charAt(0).toUpperCase() + actionName.slice(1);
            setConfirmation(true, `${capitolActionName} '${resource.name}'`,
                `Are you sure you would like to ${actionName} the ${resource.type} '${resource.name}'?`,
                (option, checkboxes)=>{

                    // with only one option other than cancel we can assume it was pressed
                    // if we are here (canel doesnt trigger onConfirm)
                    let doRecursive = (checkboxes.length > 0)? checkboxes[0]: false;

                    let loadMessage = `${capitolActionName} '${resource.name}' `;
                    if(doRecursive && canRecurs){
                        loadMessage += `and its contents...`
                        setLoading(true, loadMessage);
                    } else {
                        loadMessage += `...`;
                    }

                    ObservableUtil.callActionSubscribers(actionId, resource.id, null, false);

                    actionFunction(resource.id, CircuitsUtil.getPluralFromResourceType(resource.type), doRecursive)
                    .then( res =>{
                        if(doRecursive && canRecurs) setLoading(false);
                        ObservableUtil.callChangeSubscribers(actionId, resource.id, res);
                        if(res.ids){
                            ObservableUtil.callActionSubscribers(actionId, res.ids.filter(data=>(data.status == "success")).map(data=>data.id), res);
                        }
                    })
                    .catch( err =>{
                            if(doRecursive && canRecurs) setLoading(false);
                            ObservableUtil.callActionSubscribers(actionId, resource.id, null, true);
                            ObservableUtil.callChangeSubscribers(actionId, resource.id, err, true);
                        })

                }, [capitolActionName], checkboxes
            );
        });
    }


    _checkHasRecursiveChildren(handleError, resource, setLoading){
        switch(resource.type){
            case "library":
                // library only has recursive children if it has a saved snapshot.
                return Promise.resolve(CircuitsUtil.getMostRecentVersion(resource) != -1);
            case "package":
                if(CircuitsUtil.getMostRecentVersion(resource) == -1) return Promise.resolve(false)
                setLoading(true, "Loading...");
                return ContentServerClient.getColabDoc(handleError, "packages", resource.id)
                            .then(res => {
                                setLoading(false);

                                let body = res.body;
                                let model = body.model3d;
                                if(!model) return false;

                                let $class = model.$class;
                                if($class === "Model3DReference") return true;
                                else return false;
                            })
                            .catch(()=>{
                                setLoading(false);
                                return false;
                            })
            default:
                return Promise.resolve(false);
        }
    }

    _getRecursiveMessage(action, type){
         switch(type){
            case "library":
                return`Also ${action} all of the packages and 3D models used by this library.`;
            case "package":
                return `Also ${action} the 3D model used by this package.`;
        }
    }


    /* ----------------------------- HUBS -----------------------------*/
    addMember(handleError, {hubId, inviteEmail}, setLoading){
        setLoading(true, `Adding member...`);
        ContentServerClient.sendInvitationMembersHub(handleError, {hubId, inviteEmail})
            .then(() => ContentServerClient.getInvitesHub(handleError, hubId))
            .then(({invites}) => {
                setLoading(false);
                // this needs a more specific key
                ObservableUtil.callChangeSubscribers("addMember", hubId, {invites});
            })
            .catch(err => {
                setLoading(false);
                ObservableUtil.callChangeSubscribers("addMember", hubId, err, true);
            });
    }

    cancelInvitationMember(handleError, {lookup, hubId}, setLoading){
        setLoading(true, `Canceling Invitation...`);
        ContentServerClient.cancelInvitationHub(handleError, {hubId, lookup})
            .then(() => ContentServerClient.getInvitesHub(handleError, hubId))
            .then(({invites}) => {
                setLoading(false);
                ObservableUtil.callChangeSubscribers("cancelInvitation", hubId, {invites});
            })
            .catch(err => {
                setLoading(false);
                ObservableUtil.callChangeSubscribers("cancelInvitation", hubId, err, true);
            });
        }

        deleteMember(handleError, {userId, hubId, name, isOwnEntry = false}, setLoading){
            setLoading(true, `Deleting member...`);
            ContentServerClient.deleteMemberHub(handleError, {hubId, userId})
            .then(() => isOwnEntry ? {} : ContentServerClient.getMembersHub(handleError, hubId))
            .then(({members}) => {
                setLoading(false);
                ObservableUtil.callChangeSubscribers("deleteMember", hubId, {members, isOwnEntry});
            })
            .catch(err => {
                setLoading(false);
                ObservableUtil.callChangeSubscribers("deleteMember", hubId, err, true);
            });
    }

    transferOwnershipHub(handleError, data, setConfirmation, setLoading){
        setConfirmation(true, `Transfer Ownership?`,
                             `Are you sure you want to transfer ownership of the ${fullHubAlias} <span class="bold">${data.hub.name}</span> to
                               <span class="bold">${data.newOwner.name}</span>?
                               Once they accept the transfer, your role will be changed to Contributor, and you will no longer be able to add or remove members from the ${hubAlias}.`,
            () => {
                setLoading(true, `Sending invitation ${data.newOwner.name}`);
                return ContentServerClient.sendInvitationTransferHub(handleError, {hubId: data.hub.id, idNewOwner: data.newOwner.id})
                    .then(() => ContentServerClient.getMembersHub(handleError, data.hub.id))
                    .then(({members}) => {
                       setLoading(false)
                       ObservableUtil.callChangeSubscribers("transferring", data.hub.id, {members});
                    })
                    .catch(err => {
                       setLoading(false);
                       ObservableUtil.callChangeSubscribers("transferring", data.hub.id, err, true);
                    });
            }
        );
   }

    cancelTransferOwnershipHub(handleError, data, setConfirmation, setLoading){
        setConfirmation(true, `Cancel Transfer Ownership`,
                             `Are you sure you want to cancel tranfer ownership of <span class="bold">${data.hub.name}</span> to
                               <span class="bold">${data.newOwner.name}</span>?`,
            () => {
                setLoading(true, `Canceling invitation ${data.newOwner.name}`);
                return ContentServerClient.getListTransfersFrom(handleError)
                        .then(({transfers}) => transfers.reduce((accum, {id: transferId, to: {id:idNewOwner}, hub: {id:hub_id}}) => {
                                                   if(idNewOwner === data.newOwner.id && data.hub.id === hub_id){ accum = transferId}
                                                   return accum;
                                               },0)
                        )
                        .then(transferId => ContentServerClient.cancelTransferHub(handleError, {transferId}))
                        .then(() => ContentServerClient.getMembersHub(handleError, data.hub.id))
                        .then(({members}) => {
                           setLoading(false)
                           ObservableUtil.callChangeSubscribers("cancelTransferring", data.hub.id, {members});
                        })
                        .catch(err => {
                           setLoading(false);
                           ObservableUtil.callChangeSubscribers("transferring", data.hub.id, err, true);
                        });
            }
        )
    }
}

module.exports = new DataActionUtil();
